"use client";

import type { FC, Ref } from "react";

import { TemplatesParser } from "../../components";
import type { TemplateCollection } from "../../types";
import { Flex } from "@huub-web/ui";

export interface CenterTemplateProps {
  templates: TemplateCollection;
}

/**
 * @deprecated
 */
export const CenterTemplate: FC<
  CenterTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, ref }) => (
  <Flex ref={ref} direction="column" justify="center" align="center" grow>
    <TemplatesParser level={0} templates={templates} />
  </Flex>
);
